module.exports = __webpack_public_path__ + "../assets/telma-logo.png";